import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { NGXLogger } from 'ngx-logger';
@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  //@Input() message = new BehaviorSubject(null);

  private _messageSubject = new BehaviorSubject(null);
  notification = {subject:'', body:''};
  isShown:boolean = false;

  @Input()
  set message(val:any){
    if(val){
      this._messageSubject = val;
    }
  }
  get message():any{
    return this._messageSubject;
  }

  constructor(private logger:NGXLogger) { }

  ngOnInit() {
    this._messageSubject.subscribe((val) => {
      if(val){
        this.logger.debug(val, 'val');

        if(val.subject){
          this.notification = val;
          this.isShown = true;
          setTimeout(_ => this.isShown = false,8000);
        }
      }
    })
  }

  ngOnDestroy(){

    //this._messageSubject.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/notification/notification.component.ts